<template>
	<div>
		<div class="bottom-left-top2">
				  		  <div class="bottom-left-top-left">
							  <div class="bianYaQiRongLiang">变压器容量</div>
							   <div class="bianYaQiRongLiang-Number">
								   <div ><span class="number">{{target[0].transformer_capacity}}</span> <span class="unit">KVa</span></div>
							   </div>
						  </div>
						  <div class="bottom-left-top-right">
							  <div class="yongidanliang">
								  <span class="yongidanliangTitle">年度用电量</span>
								  <span class="yongidanliangNumber"><span class="bottom-left-top-number">{{target[2].total_elect_amount}}</span><span class="yongidanliangUnit">MWh</span></span> 
							  </div>
							  <div class="ketiaorongliang">
								  <span class="ketiaorongliangTitle">可调容量</span>
								  <span class="ketiaorongliangNumber"><span class="bottom-left-top-number">{{target[1].available_capacity}}</span><span class="ketiaorongliangUnit">kW</span></span> 
							  </div>
						  </div>
		</div>
		<div class="bottom-left-bottom2">
			<img  class="bottom-left-bottom-img" :src="url" alt="">
				<!-- <img  class="bottom-left-bottom-img" src="~@/assets/images/exposition/xunidianchang-jutizhaopian.png" alt="">  -->
		</div> 
	</div>
</template>

<script>
	import {
			dataInterface
		} from '@/api/dataInterfaceApi';
		export default {
			components: {},
			data() {
				return {
					target: [
					  {
					    transformer_capacity: "",
					  },
					  {
					    
					    available_capacity: "",
					    
					  },
					  {
						  total_elect_amount:"",
					  },
					],
					url:'',
				}
			},
		destroyed() {
		  this.$bus.$off("updateBianyaqi");
		},
		mounted() {
		  this.$bus.$on("updateBianyaqi", () => {
				// console.log(99776666)
		    this.getphotovoltaic();
			this.getNianduyongliang();
			this.initImg();
		  });
		  this.getphotovoltaic();
		  this.getNianduyongliang();
		  this.initImg();
		  // this.getData();
		},
		methods: {
		  nowType() {
		    return localStorage.getItem("typeTime") || "日";
		  },
		  initImg() {
		  	  // this.videoObj = {}
		  	  var params = {
		  	    "stationId": 
		  		// '0217fb691abe4b3abb5adb4ed72b590b'
		  		localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") :
		  		'0217fb691abe4b3abb5adb4ed72b590b',
		  		// pageSize: this.listQuery.pageSize,
		  		// currentPage: this.listQuery.currentPage
		  	  }
		  	  this.showVideo = false
		  	  
		  	  this.url = ''
		  	  dataInterface
		  	  .gclVideoLiveInfoExposition1(params)
		  	  .then((res) => {
				  // console.log(res[0].stationImage[0].url,'res[0].stationImage[0].url')
				  this.url=`https://sass.gclme.com`+res[0].stationImage[0].url;
				  // console.log(this.url,'this.url1111')
		  	  })
		  	  .catch((err) => {
		  		console.log(err);
		  	  });
		  	},
		  getphotovoltaic() {
		    let params = {
		      enCode: "powerplant-right-hdzljzb",
		      "@station_id": localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") : '0217fb691abe4b3abb5adb4ed72b590b'
		    };
		    dataInterface
		      .dataFaceApi(params)
		      .then((res) => {
		        let data = res[0] || {};
		        this.target[0].transformer_capacity = data.transformer_capacity || 0;
		        this.target[1].available_capacity = data.available_capacity || 0;
		      })
		      .catch((err) => {
		        console.log(err);
		      });
		  },
		  getNianduyongliang() {
		    let params1 = {
		      enCode: "powerplant-right-hdzjczb",
		      "@station_id": localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") : '0217fb691abe4b3abb5adb4ed72b590b'
		    };
		    dataInterface
		      .dataFaceApi(params1)
		      .then((res) => {
		        // console.log(res, "年度用量");
		        let data1 = res[0] || {};
		        this.target[2].total_elect_amount = Math.trunc(data1.total_elect_amount) || 0;
		      })
		      .catch((err) => {
		        console.log(err);
		      });
		  },
		},
		}
</script>


<style lang="scss" scoped>
@import "./comm.scss";
@font-face {
  font-family: "DS-Digital-Bold";
  src: url("~@/assets/font/DS-Digital-Bold.ttf");
}
.DS-Digital-Bold {
  font-family: "DS-Digital-Bold";
}
	.bottom-left-top2{
		width: 764px;
		height:  150px;
		display: flex;
	// background-color: rgb(98, 209, 135);
		.bottom-left-top-left{
			width: 382px;
			height: 150px;
			float: left;
			// background-color: green;
			// display: flex;
			background:url("~@/assets/images/exposition/xunidianchang-bianyaqirongliang.png")no-repeat;
			 background-size: 100% 100%;
			// z-index: 100000;
			.bianYaQiRongLiang{
				font-size: $FontSize36;
				padding-left: 170px;
				padding-top: 25px;
			}
			.bianYaQiRongLiang-Number{
					font-size: $FontSize48;
					  color: #00FDF4;
					  padding-left: 160px;
					 height: 90px;
					 line-height: 90px;
					  .number,.unit{
						  
						      font-family: 'HT';
						     
						  
						   // font-family: "DS-Digital-Bold"
					  }
			}
			
		}
		.bottom-left-top-right{
			width: 382px;
			// flex: 1;
			height: 150px;
			// 
			// background-color:red;
			.yongidanliang,.ketiaorongliang{
				display: flex;
			}
			.yongidanliangTitle,.ketiaorongliangTitle{
				font-size: $FontSize32;
				width: 230px;
				height: 82px;
				line-height: 32px;
				padding-left: 55px;
				display: block;
				// background-color: red;
			}
			.yongidanliangTitle,.yongidanliangNumber{
				padding-top: 35px;
			}
			.ketiaorongliangTitle,.ketiaorongliangNumber{
				padding-top: 27px;
			}
			.ketiaorongliangNumber,.yongidanliangNumber{
				 display: block;
				height: 82px;
				line-height: 32px;
				 font-size: $FontSize48;
				  padding-left: 10px;
			}
			.yongidanliangUnit,.ketiaorongliangUnit{
				font-size: $FontSize32;
			}
			.bottom-left-top-number{
				 font-family: "DS-Digital-Bold";
				  color: #00FDF4;
			}
			
		}
	}
	.bottom-left-bottom2{
		padding-top: 15px;
		.bottom-left-bottom-img{
			display: block;
			height: 458px;
			width: 759px;
			padding-left: 20px;
		}
	}
</style>